export type Lang = 'ja' | 'en'

export const translations = {
  ja: {
    // Navigation
    nav_dashboard: 'ダッシュボード',
    nav_reports: 'レポート',
    nav_calendar: 'カレンダー',
    nav_transactions: '取引',
    nav_accounts: '口座',
    nav_credit_cards: 'クレジットカード',
    nav_budget: '予算',
    nav_recurring: '定期取引',
    nav_investments: '投資',
    nav_balance: '収支',
    nav_life_plan: 'ライフプラン',
    // Investments
    inv_title: '証券口座',
    inv_subtitle: '証券口座ごとの保有商品と評価額',
    inv_total_market_value: '評価額合計',
    inv_total_cost: '取得金額',
    inv_total_cost_sum: '取得金額合計',
    inv_total_gain_loss: '評価損益',
    inv_price_auto_updated: '基準価額は毎日 21 時に自動更新（最終更新 {datetime}）',
    inv_price_auto_updated_never: '基準価額は毎日 21 時に自動更新されます',
    inv_day_change: '前日比',
    inv_add_brokerage: '+ 証券口座を追加',
    inv_brokerage_name: '口座名',
    inv_brokerage_name_hint: '同じ証券会社で口座を分けて管理したいときに変更します（未入力なら証券会社名がそのまま入ります）。',
    inv_brokerage_institution: '証券会社',
    inv_brokerage_modal_add: '証券口座を追加',
    inv_brokerage_modal_edit: '証券口座を編集',
    inv_brokerage_delete_confirm: '「{name}」を削除しますか？紐づく保有商品と口座もまとめて削除されます。',
    inv_no_brokerages: '登録済みの証券口座はありません。まず証券口座を追加してください。',
    inv_unlinked_accounts: '保有商品が未登録の証券口座',
    inv_unlinked_accounts_hint: '証券会社の情報が紐づいていない証券口座です。残高だけを手で管理している口座はここに並びます。',
    inv_import_csv: 'CSVを取込',
    inv_importing: '取込中...',
    inv_import_result: '{imported} 件の明細を取り込みました（重複 {skipped} 件をスキップ）',
    inv_import_hint: '楽天証券の「取引履歴（投資信託）」CSV と、SBI証券 iDeCo の「取引履歴」CSV に対応しています。',
    inv_add_product: '+ 商品を追加',
    inv_product_modal_add: '商品を追加',
    inv_product_modal_edit: '商品を編集',
    inv_product_name: '商品名',
    inv_product_category: '投資商品カテゴリー',
    inv_product_quantity: '数量',
    inv_product_account_type: '預り区分',
    inv_product_account_type_hint: 'つみたてNISA / NISAつみたて投資枠 / 特定 など。同じ商品でも区分ごとに分けて管理します。',
    inv_product_fund_cd: '協会コード',
    inv_product_fund_cd_hint: '投資信託協会のファンドコード。入力すると基準価額を自動取得します（三菱UFJアセットマネジメントのファンドのみ）。',
    inv_product_cost: '取得金額',
    inv_product_delete_confirm: '「{name}」を削除しますか？取り込んだ売買明細も削除されます。',
    inv_no_products: '保有商品はありません。CSV を取り込むか、商品を追加してください。',
    inv_col_product: '商品名',
    inv_col_account_type: '預り区分',
    inv_col_quantity: '数量',
    inv_col_price: '基準価額',
    inv_col_market_value: '評価額',
    inv_col_cost: '取得金額',
    inv_col_gain_loss: '評価損益',
    inv_account_type_none: '区分なし',
    inv_account_type_breakdown: '預り区分の内訳',
    inv_account_type_breakdown_rest: 'ほか',
    inv_account_type_breakdown_empty: '基準価額が取れている保有商品がありません。',
    inv_price_unavailable: '未取得',
    inv_price_as_of: '基準日 {date}',
    inv_unpriced_warning: '基準価額を取得できていない商品が {count} 件あります。協会コードを設定するか、基準価額を手入力してください。',
    inv_category_equity_fund: '株式投資信託',
    inv_category_bond_fund: '公社債投資信託',
    inv_category_domestic_stock: '国内株式',
    inv_category_foreign_stock: '外国株式',
    inv_category_etf: 'ETF（上場投資信託）',
    inv_category_reit: 'REIT（不動産投資信託）',
    inv_category_bond: '債券',
    inv_category_other: 'その他',
    nav_settings: '設定',
    nav_logout: 'ログアウト',
    nav_collapse_sidebar: 'サイドバーを折りたたむ',
    nav_expand_sidebar: 'サイドバーを展開する',
    // Settings
    settings_title: '設定',
    tab_categories: 'カテゴリ管理',
    tab_csv: 'データ入出力',
    tab_security: 'セキュリティ',
    tab_language: '言語',
    tab_appearance: '外観',
    tab_members: 'メンバー',
    tab_integrations: '外部連携',
    // Wise integration
    wise_title: 'Wise 連携',
    wise_desc: 'Wise の Personal Token を登録すると、残高と取引履歴を自動で取り込めます。',
    wise_token_note: 'Wise 側で読み取り専用（Read-Only）トークンを発行することを推奨します。',
    wise_token_placeholder: 'Personal Token を入力',
    wise_connect_btn: '接続',
    wise_connecting: '接続中...',
    wise_connections_title: '接続済みプロファイル',
    wise_no_connections: '接続済みの Wise アカウントはありません',
    wise_delete: '接続を解除',
    wise_delete_confirm: '「{name}」の接続を解除しますか？取り込み済みの取引は残ります。',
    wise_balances_title: 'Wise 残高',
    wise_balances_empty: '残高が見つかりません',
    wise_link_btn: '口座として追加',
    wise_linking: '追加中...',
    wise_linked_badge: '連携済み',
    wise_sync_btn: '同期',
    wise_sync_full_btn: '全期間',
    wise_syncing: '同期中...',
    wise_last_synced: '最終同期',
    wise_never_synced: '未同期',
    wise_sync_result: '{imported} 件の取引を取り込みました（更新 {updated} 件 / 取り込み済み {skipped} 件）',
    appearance_title: 'テーマ',
    appearance_system: 'システムに合わせる',
    appearance_light: 'ライト',
    appearance_dark: 'ダーク',
    amount_unit_title: '金額の表示単位',
    amount_unit_desc: '一覧やグラフに出る金額の桁を切り替えます。万円にしても、1 万円未満は円のまま表示します。1 億以上は億で括ります。',
    amount_unit_yen: '円（¥1,234,567）',
    amount_unit_man: '万円（123.5万円 / 1億5400.5万円）',
    // Members
    members_desc: '資産の持ち主を登録します。口座に持ち主を紐づけると、ダッシュボードで人ごとの資産を確認できます。',
    members_add: '+ 追加',
    members_edit: '編集',
    members_delete: '削除',
    members_delete_confirm: '「{name}」を削除しますか？',
    members_empty: '登録済みのメンバーはいません',
    members_accounts_count: '口座 {count} 件',
    member_modal_add: 'メンバーを追加',
    member_modal_edit: 'メンバーを編集',
    member_name_label: '名前',
    member_name_placeholder: '例: 太郎',
    member_birth_date_label: '生年月日',
    member_birth_date_hint: '入力すると一覧に年齢が表示されます（任意）',
    member_age_display: '{age}歳',
    member_color_label: 'カラー',
    // Category
    categories_custom: 'カスタムカテゴリ',
    categories_default: 'デフォルトカテゴリ',
    categories_add: '+ 追加',
    categories_edit: '編集',
    categories_delete: '削除',
    categories_delete_confirm: '「{name}」を削除しますか？',
    categories_empty: 'カスタムカテゴリはありません',
    categories_default_badge: 'デフォルト',
    category_modal_add: 'カテゴリを追加',
    category_modal_edit: 'カテゴリを編集',
    category_icon_label: 'アイコン（絵文字）',
    category_name_label: 'カテゴリ名',
    category_type_label: '種別',
    category_color_label: 'カラー',
    type_expense: '支出',
    type_income: '収入',
    type_transfer: '振替',
    // CSV
    csv_export_title: 'CSV エクスポート',
    csv_export_desc: 'すべての取引データを CSV ファイルとしてダウンロードします。',
    csv_export_btn: 'CSV ダウンロード',
    csv_exporting: 'エクスポート中...',
    csv_import_title: 'CSV インポート',
    csv_import_desc: 'CSV ファイルから取引を一括インポートします。複数ファイルを同時に選択できます。',
    csv_import_btn: 'CSVファイルを選択（複数可）',
    csv_importing: 'インポート中...',
    csv_import_format_label: 'CSV フォーマット',
    csv_format_generic: '汎用フォーマット',
    csv_format_rakuten: '楽天カード',
    csv_format_paypay_card: 'PayPayカード',
    csv_format_view_card: 'ビューカード',
    csv_format_smbc_card: '三井住友カード',
    csv_format_sbi_net_bank: 'ドコモSMTBネット銀行',
    csv_format_gmo_aozora_bank: 'GMOあおぞらネット銀行',
    csv_format_rakuten_bank: '楽天銀行',
    csv_format_paypay_bank: 'PayPay銀行',
    csv_import_account_label: '取り込み先の口座',
    csv_import_account_placeholder: '口座を選択',
    csv_import_select_account_error: '取り込み先の口座を選択してください',
    csv_import_account_no_match: '選択したフォーマットに対応する口座が見つかりません。全口座から選択できますが、口座の金融機関を設定しておくと次回から候補が絞り込まれます。',
    csv_import_rakuten_note: '楽天e-NAVIからダウンロードした利用明細CSV（Shift-JIS）に対応します。カテゴリは利用店名から自動推定され、推定できない場合は「その他」になります。同じ明細を重複して取り込んでも、重複分は自動でスキップされます。',
    csv_import_paypay_card_note: 'PayPayカード会員メニューからダウンロードした利用明細CSV（UTF-8）に対応します。金額は手数料込みの支払総額を使い、キャンセル・返金（マイナス計上）は収入として取り込みます。カテゴリは利用店名から自動推定され、推定できない場合は「その他」になります。分割・リボの支払区分と手数料はメモに記録されます。同じ明細を重複して取り込んでも、重複分は自動でスキップされます。',
    csv_import_view_card_note: 'VIEW\'s NETからダウンロードしたご利用明細CSV（Shift-JIS）に対応します。金額は手数料・利息込みのご請求額を使い、払戻・キャンセルは収入として取り込みます。カテゴリはご利用箇所から自動推定され（Suicaオートチャージは交通費）、推定できない場合は「その他」になります。1回払い以外の支払区分と海外利用の現地通貨額はメモに記録されます。同じ明細を重複して取り込んでも、重複分は自動でスキップされます。',
    csv_import_smbc_card_note: 'Vpassからダウンロードした利用明細CSV（Shift-JIS）に対応します。カテゴリは利用店名から自動推定され、推定できない場合は「その他」になります。1回払い以外の支払回数と備考欄はメモに記録されます。同じ明細を重複して取り込んでも、重複分は自動でスキップされます。',
    csv_import_sbi_net_bank_note: 'ドコモSMTBネット銀行（NEOBANK）からダウンロードした入出金明細CSV（Shift-JIS）に対応します。出金は支出、入金は収入として取り込み、カテゴリは内容欄から自動推定されます。残高欄は使用しません（口座残高は取り込んだ取引の差分で更新されます）。同じ明細を重複して取り込んでも、重複分は自動でスキップされます。',
    csv_import_gmo_aozora_bank_note: 'GMOあおぞらネット銀行からダウンロードした入出金明細CSV（Shift-JIS）に対応します。日付は区切り無しの8桁（YYYYMMDD）に対応し、出金は支出、入金は収入として取り込みます。カテゴリは摘要欄から自動推定され、Pay-easy の税金・公金納付（「PE 立川税務署」など）は「その他」になります。残高欄は使用しません（口座残高は取り込んだ取引の差分で更新されます）。同じ明細を重複して取り込んでも、重複分は自動でスキップされます。',
    csv_import_rakuten_bank_note: '楽天銀行からダウンロードした入出金明細CSV（Shift-JIS）に対応します。日付は区切り無しの8桁（YYYYMMDD）、金額は「入出金(円)」1列の符号で表されるため、マイナスは支出・プラスは収入として取り込みます。カテゴリは入出金内容から自動推定され、カナ書きの税金・公金（「シミンゼイ」など）や他行への振込は「その他」になります。残高欄は使用しません（口座残高は取り込んだ取引の差分で更新されます）。同じ明細を重複して取り込んでも、重複分は自動でスキップされます。',
    csv_import_paypay_bank_note: 'PayPay銀行からダウンロードした入出金明細CSV（Shift-JIS）に対応します。日付は年・月・日が別々の列に入る形式（操作日(年)/(月)/(日)）に対応し、「お支払金額」は支出、「お預り金額」は収入として取り込みます。カテゴリは摘要欄から自動推定され、店名が入らないVisaデビットの利用、カナ書きの税金・公金（Pay-easy の「PE ヒガシムラヤマゼイムシヨ」など）、他行への振込は「その他」になります。「決算お利息」やVisaデビットのキャッシュバックは「その他収入」です。操作時刻と取引順番号は使用しません（Zeniの取引は日付単位のため）。残高欄も使用しません（口座残高は取り込んだ取引の差分で更新されます）。同じ明細を重複して取り込んでも、重複分は自動でスキップされます。',
    csv_import_file_no_rows: '{name} からインポートできる行がありません',
    // Security
    security_reset_title: 'パスワードリセット',
    security_reset_desc: '登録済みのメールアドレスにリセット用リンクを送信します。',
    security_email_placeholder: 'メールアドレス',
    // Language
    language_title: '表示言語',
    language_ja: '日本語',
    language_en: 'English',
    // Common
    common_save: '保存',
    common_saving: '保存中...',
    common_cancel: 'キャンセル',
    common_send: '送信',
    common_sending: '送信中...',
    common_loading: '読み込み中...',
    common_save_error: '保存に失敗しました',
    common_delete_error: '削除に失敗しました',
    common_send_error: '送信に失敗しました',
    common_fetch_error: '取得に失敗しました',
    common_update_error: '更新に失敗しました',
    common_edit: '編集',
    common_add: '追加',
    common_delete: '削除',
    common_today: '今日',
    common_no_data: 'データなし',
    common_not_set: '未設定',
    common_year_month: '{year}年{month}月',
    common_year_month_day: '{year}年{month}月{day}日',
    common_month_n: '{n}月',
    common_day_sun: '日',
    common_day_mon: '月',
    common_day_tue: '火',
    common_day_wed: '水',
    common_day_thu: '木',
    common_day_fri: '金',
    common_day_sat: '土',
    // Dashboard
    dashboard_title: 'ダッシュボード',
    dashboard_subtitle: '家計の概要',
    dashboard_total_assets: '総資産',
    dashboard_daily_change: '前日比',
    dashboard_market_title: 'マーケット',
    dashboard_market_sp500: 'S&P 500',
    dashboard_market_usdjpy: '米ドル/円',
    dashboard_market_error: 'マーケットデータを取得できませんでした',
    dashboard_econ_title: '日本の景気指標',
    dashboard_econ_error: '景気指標を取得できませんでした',
    dashboard_econ_about: '指標について',
    dashboard_econ_about_body: '政府が公表する統計をそのまま表示しています。月次・四半期の公表なので、値が変わるのは月に数回だけです。',
    dashboard_econ_change: '前回比',
    econ_MONTHLY_ECONOMIC_REPORT: '月例経済報告（基調判断）',
    econ_GDP_REAL_ANNUALIZED: '実質GDP成長率（前期比年率）',
    econ_BUSINESS_CI_COINCIDENT: '景気動向指数（一致CI）',
    econ_BUSINESS_CI_LEADING: '景気動向指数（先行CI）',
    econ_WATCHER_CURRENT_DI: '景気ウォッチャー 現状判断DI',
    econ_WATCHER_OUTLOOK_DI: '景気ウォッチャー 先行き判断DI',
    econ_CPI_ALL: '消費者物価指数 総合（前年同月比）',
    econ_CPI_CORE: '消費者物価指数 コア（前年同月比）',
    econ_REAL_WAGE_YOY: '実質賃金指数（前年同月比）',
    econ_UNEMPLOYMENT_RATE: '完全失業率（季節調整値）',
    econ_JOB_OPENINGS_RATIO: '有効求人倍率（季節調整値）',
    dashboard_month_income: '今月収入',
    dashboard_month_expense: '今月支出',
    dashboard_month_balance: '今月差引',
    dashboard_recent_tx: '最近の取引',
    dashboard_no_tx: '取引がありません',
    dashboard_asset_trend: '資産推移',
    dashboard_asset_trend_months: '{n}ヶ月',
    dashboard_asset_composition: '資産構成',
    dashboard_asset_share: '総資産の {percent}%',
    dashboard_member_assets: 'メンバー別資産',
    dashboard_member_unassigned: '所有者未設定',
    dashboard_member_share: '総資産の {percent}%',
    dashboard_member_assets_empty: '設定でメンバーを追加し、口座に所有者を紐づけると人ごとの資産が表示されます。',
    dashboard_goal_title: '目標達成まで',
    dashboard_goal_pace_label: 'このペースで達成まで',
    dashboard_goal_days: 'あと {days}日',
    dashboard_goal_years: 'あと約 {years}年',
    dashboard_goal_over_years: '{years}年以上かかる見込み',
    dashboard_goal_achieved: '目標達成',
    dashboard_goal_pace_label_decreasing: '資産の増減ペース',
    dashboard_goal_pace_monthly: '月 {amount}',
    dashboard_goal_estimated_date: '{date} 頃',
    dashboard_goal_confidence: '確度 {percent}%',
    dashboard_goal_outlook_short: '{years}年後 {amount}',
    dashboard_goal_basis: '予測の根拠',
    dashboard_goal_basis_pace: '資産の傾き（直近{months}ヶ月）',
    dashboard_goal_basis_cashflow: '月次収支の平均（参考）',
    dashboard_goal_basis_fit: '直線へのあてはまり（R²）',
    dashboard_goal_basis_deviation: '月ごとのばらつき（±）',
    dashboard_goal_basis_outlook: '{years}年後の見込み',
    dashboard_goal_basis_range: '95%の範囲 {low} 〜 {high}',
    dashboard_goal_basis_note: '直近{months}ヶ月の総資産（{points}点）に最小二乗法で直線を当て、その傾きを今の総資産から先に伸ばした目安です。確度はあてはまり（R²）を予測期間の長さで割り引いた値で、相場の変動や臨時の収支は織り込んでいません。',
    dashboard_goal_remaining: '残り',
    dashboard_goal_target: '目標',
    dashboard_goal_empty: '目標金額を設定すると、達成までの期間の目安が出ます。',
    dashboard_goal_set: '目標金額を設定',
    dashboard_goal_edit: '目標金額を編集',
    dashboard_goal_amount_label: '目標とする総資産',
    dashboard_goal_amount_hint: '直近{months}ヶ月の資産の増え方から、達成までの期間を見積もります。',
    dashboard_goal_delete: '目標を削除',
    dashboard_goal_delete_confirm: '目標金額を削除しますか？',
    // Transactions
    transactions_title: '取引',
    transactions_subtitle: '収支を管理する',
    transactions_add: '取引を追加',
    transactions_modal_title: '取引を追加',
    transactions_modal_edit_title: '取引を編集',
    transactions_delete: '削除',
    transactions_delete_confirm: 'この取引を削除しますか？',
    transactions_no_result: '取引が見つかりません',
    transactions_csv_export: 'CSV 出力',
    transactions_csv_exporting: '出力中...',
    transactions_filter_all_accounts: '全口座',
    transactions_filter_all_to_accounts: '全振替先',
    transactions_filter_all_types: '全種別',
    transactions_filter_all_categories: '全カテゴリ',
    transactions_filter_search: '説明・メモで検索',
    // Date range picker
    date_range_placeholder: '期間を選択',
    date_range_pick_start: '開始日を選択',
    date_range_pick_end: '終了日を選択',
    date_range_this_month: '今月',
    date_range_last_month: '先月',
    date_range_this_year: '今年',
    date_range_last_30_days: '直近30日',
    date_range_clear: 'クリア',
    date_range_prev_month: '前の月',
    date_range_next_month: '次の月',
    // Amount range picker
    amount_range_placeholder: '金額を指定',
    amount_range_min: '下限（円）',
    amount_range_max: '上限（円）',
    amount_range_no_limit: '上限なし',
    amount_range_hint: '片方だけの指定もできます',
    amount_range_preset_under_10k: '〜1万円',
    amount_range_preset_10k_50k: '1〜5万円',
    amount_range_preset_50k_100k: '5〜10万円',
    amount_range_preset_over_100k: '10万円〜',
    amount_range_target: '対象',
    amount_range_target_both: '収入・支出どちらも',
    amount_range_target_all: '未選択なら全種別',
    amount_range_target_transfer_only: '振替のみ',
    amount_range_clear: 'クリア',
    amount_range_apply: '適用',
    transactions_col_date: '日付',
    transactions_col_description: '説明',
    transactions_col_category: 'カテゴリ',
    transactions_col_type: '種別',
    transactions_col_account: '口座',
    transactions_col_amount: '金額',
    transactions_pagination: '全 {total} 件 / {page} ページ目（全 {totalPages} ページ）',
    transactions_prev: '前へ',
    transactions_next: '次へ',
    transactions_per_page: '件/ページ',
    transactions_summary_count: '件数',
    transactions_summary_expense: '支出合計',
    transactions_summary_income: '収入合計',
    transactions_summary_transfer: '振替合計',
    transactions_summary_net: '収支',
    transactions_summary_average: '平均金額',
    transactions_summary_unit: '{count} 件',
    transactions_summary_truncated: '※ 件数が多いため先頭 {count} 件で集計しています',
    transactions_summary_selected_note: '※ 選択中の {count} 件だけを集計しています',
    transactions_form_type: '種別',
    transactions_form_date: '日付',
    transactions_form_description: '説明',
    transactions_form_description_placeholder: '例: スーパーで買い物',
    transactions_form_category: 'カテゴリ',
    transactions_form_amount: '金額',
    transactions_form_account: '口座',
    transactions_form_account_placeholder: '口座を選択',
    transactions_form_from_account: '出金元口座',
    transactions_form_to_account: '振替先口座',
    transactions_form_to_account_placeholder: '振替先口座を選択',
    transactions_form_to_account_hint: '出金元から引かれた金額が振替先に加算されます（クレジットカードなら利用枠が戻ります）。振替は収入・支出として集計されません。',
    transactions_form_to_account_required: '振替先口座を選択してください',
    transactions_form_account_required: '口座を選択してください',
    transactions_filter_search_accounts: '口座を検索',
    transactions_filter_search_to_accounts: '振替先を検索',
    transactions_filter_clear: '条件をクリア',
    // 振替の向き（出金元 → 振替先）
    transactions_transfer_from_label: '出金元',
    transactions_transfer_to_label: '振替先',
    transactions_transfer_unselected: '未選択',
    transactions_transfer_mixed_accounts: '{count} 口座',
    transactions_transfer_mixed_types: '種別が混在',
    transactions_transfer_from_hint: '出金元が{type}のときの、よく使う振替先を上に出しています。',
    transactions_transfer_from_unknown_hint: '先に出金元口座を選ぶと、振替先の候補を絞り込みます。',
    transactions_transfer_mixed_hint: '選択した取引の出金元が複数の種別にまたがっているため、候補を絞り込めません。',
    transactions_form_to_account_group_others: 'その他の口座',
    transactions_form_to_account_show_all: 'すべての口座から選ぶ',
    transactions_form_to_account_no_option: '選べる振替先の口座がありません',
    // 出金元と振替先の組み合わせが表す意味
    transfer_pattern_card_payment: 'カードの引き落とし',
    transfer_pattern_card_payment_desc: '{from}から引き落とされ、{to}の利用残高が同額戻ります。',
    transfer_pattern_between_banks: '口座間の資金移動',
    transfer_pattern_between_banks_desc: '{from}の残高が減り、{to}の残高が同額増えます。総資産は変わりません。',
    transfer_pattern_withdrawal: '現金の引き出し',
    transfer_pattern_withdrawal_desc: '{from}の残高が減り、{to}の現金が同額増えます。',
    transfer_pattern_deposit: '口座への入金',
    transfer_pattern_deposit_desc: '{from}の現金が減り、{to}の残高が同額増えます。',
    transfer_pattern_investing: '証券口座への入金',
    transfer_pattern_investing_desc: '{from}の残高が減り、{to}の残高が同額増えます。',
    transfer_pattern_divestment: '証券口座からの出金',
    transfer_pattern_divestment_desc: '{from}の残高が減り、{to}の残高が同額増えます。',
    transfer_pattern_cash_advance: 'カードからの資金移動（キャッシングなど）',
    transfer_pattern_cash_advance_desc: '{to}の残高が増え、{from}の未払い額が同額増えます。',
    transfer_pattern_generic: '口座間の振替',
    transfer_pattern_generic_desc: '{from}から引かれた金額が{to}に加算されます。',
    transactions_transfer_excluded_note: '振替は収入・支出として集計されません。',
    // 振替の相手方（振替先に同額が入っている取引）の裏取り
    transactions_transfer_counterpart_checking: '相手方の取引を確認しています…',
    transactions_transfer_counterpart_found: '相手方の取引が {count} 件見つかりました',
    transactions_transfer_counterpart_none: '振替先に対応する取引が見つかりません',
    transactions_transfer_counterpart_none_hint: '{from} 〜 {to} の振替先口座に同額の入金はありませんでした。日付・金額・振替先を確認してください（このまま保存もできます）。',
    transactions_transfer_counterpart_via: '{account} からの振替',
    transactions_transfer_counterpart_error: '相手方の取引を確認できませんでした',
    transactions_transfer_counterpart_link_none: '紐付けない',
    transactions_transfer_counterpart_link_hint: '着金側にする入金を選ぶと、その入金は「振替」になり、振替先の残高が二重に増えなくなります。同額の別の入金と紛らわしいので、摘要を見て選んでください。',
    transactions_transfer_counterpart_already_linked: '紐付け済み',
    transactions_counterpart_linked_title: '{account} からの振替の着金側です',
    transactions_counterpart_linked_hint: 'この取引は振替レコードで計上済みのため、口座残高にも収支の集計にも効きません。取り違えているときは紐付けを解除してください。',
    transactions_counterpart_unlink: '紐付けを解除して収入に戻す',
    transactions_counterpart_unlinking: '解除しています…',
    transactions_excluded_badge: '対象外',
    transactions_excluded_badge_title: '集計対象外（残高には反映されます）',
    transactions_excluded_note: '集計対象外の {count} 件は収入・支出の合計から除いています。',
    transactions_filter_excluded_all: '集計対象外を含む',
    transactions_filter_excluded_exclude: '集計対象外を除く',
    transactions_filter_excluded_only: '集計対象外のみ',
    transfer_pattern_unusual: 'あまり使わない組み合わせ',
    transfer_pattern_unusual_desc: '{from}（{fromType}）から{to}（{toType}）への振替は一般的ではありません。出金元と振替先が逆になっていないか確認してください。',
    transactions_form_excluded: '集計対象外にする',
    transactions_form_excluded_hint: '口座残高には反映したまま、収支・カテゴリ内訳・予算の集計から外します。クレジットカードの投信積立のように、支出として数えたくない取引に使います。',
    transactions_form_note: 'メモ',
    transactions_form_note_placeholder: '任意のメモ',
    transactions_bulk_selected: '{count} 件を選択中',
    transactions_bulk_select_all: 'すべて選択',
    transactions_bulk_clear: '選択を解除',
    transactions_bulk_edit: '一括編集',
    transactions_bulk_delete: '一括削除',
    transactions_bulk_delete_confirm: '選択した {count} 件の取引を削除しますか？この操作は取り消せません。',
    transactions_bulk_modal_title: '{count} 件をまとめて編集',
    transactions_bulk_keep: '変更しない',
    transactions_bulk_no_change: '変更する項目を1つ以上選んでください',
    transactions_bulk_hint: '選択した取引の指定した項目だけを上書きします。口座と金額は変更されません。',
    transactions_bulk_excluded_label: '集計対象外',
    transactions_bulk_excluded_on: '集計対象外にする',
    transactions_bulk_excluded_off: '集計対象に戻す',
    transactions_bulk_updated: '{count} 件を更新しました',
    transactions_bulk_deleted: '{count} 件を削除しました',
    transactions_csv_invalid_header: 'CSVのヘッダー行が不正です。date, type, category, description, amount, accountId 列が必要です。',
    transactions_csv_no_rows: 'インポートできる行がありません',
    transactions_csv_imported: '{count}件のデータをインポートしました',
    transactions_csv_imported_result: '{count}件をインポートしました（重複のため{skipped}件をスキップ）',
    // Accounts
    accounts_title: '口座',
    accounts_total_balance: '合計残高',
    accounts_add: '口座を追加',
    accounts_show_archived: 'アーカイブを表示',
    accounts_reorder: '並べ替え',
    accounts_reorder_done: '並べ替えを終了',
    accounts_reorder_hint: 'カードをドラッグするか、← → ボタンで並び順を変えられます。動かせるのは同じ見出しのまとまりの中だけです。',
    accounts_reorder_move_prev: '前へ移動',
    accounts_reorder_move_next: '後ろへ移動',
    accounts_reorder_error: '並び順を保存できませんでした',
    accounts_card_view_transactions: 'この口座の取引を見る',
    accounts_card_balance: '残高',
    accounts_no_result: '口座が見つかりません',
    accounts_modal_add: '口座を追加',
    accounts_modal_edit: '口座を編集',
    accounts_form_name: '口座名',
    accounts_form_name_placeholder: '例: メインバンク',
    accounts_form_type: '種別',
    accounts_form_type_locked: '種別は後から変更できません',
    accounts_form_balance: '開始残高',
    accounts_form_card_brand: 'カードブランド',
    accounts_form_card_brand_none: '設定しない',
    accounts_form_credit_limit: '利用可能枠',
    accounts_form_payment_account: '引き落とし先銀行口座',
    accounts_form_payment_account_none: '設定しない',
    accounts_form_closing_day: '締め日',
    accounts_form_payment_day: '引き落とし日',
    accounts_form_payment_month: '引き落とし月',
    accounts_form_payment_month_same: '当月',
    accounts_form_payment_month_next: '翌月',
    accounts_form_payment_month_after_next: '翌々月',
    accounts_form_day_unset: '未設定',
    accounts_form_day_end_of_month: '月末',
    accounts_form_day_nth: '{day}日',
    accounts_form_billing_cycle_hint: '締め日と引き落とし日を設定すると、引き落とし日に残高が足りるかを事前に確認できます。「月末」を選ぶと、月の日数に合わせて自動で末日に丸められます。',
    accounts_card_billing_cycle: '{closing}締め {month}{payment}払い',
    accounts_card_billing_cycle_label: '締め日・引き落とし日',
    accounts_form_member: '所有者',
    accounts_form_member_none: '未設定',
    accounts_form_member_hint: '設定でメンバーを追加すると選べます。',
    accounts_card_overpaid_warning: '引き落としが利用明細を超えています',
    accounts_card_overpaid_hint: '利用明細を取り込んでいない期間の引き落としが「振替」になっていると、カード残高がプラスになり総資産が過大に出ます。その期間の引き落としは「支出」に戻してください。',
    accounts_form_institution: '金融機関',
    accounts_form_institution_placeholder: '例: 三菱UFJ銀行',
    accounts_form_color: 'カラー',
    accounts_status_active: 'アクティブ',
    accounts_status_archived: 'アーカイブ済み',
    accounts_archive: 'アーカイブ',
    accounts_unarchive: 'アーカイブ解除',
    accounts_delete_confirm: '「{name}」を完全に削除しますか？この操作は取り消せません。取引が登録されている口座は削除できません。',
    accounts_deleting: '削除中...',
    accounts_csv_import: 'CSVインポート',
    accounts_csv_import_title: 'CSVインポート：{name}',
    accounts_csv_import_format_placeholder: 'フォーマットを選択',
    accounts_csv_import_no_format: 'この口座に対応するCSVフォーマットがありません',
    accounts_section_bank: '銀行口座',
    // 口座ページでは使わない（証券口座は専用ページへ移した）。ダッシュボードの資産構成で使う
    accounts_section_investment: '証券口座',
    accounts_section_cash: '現金',
    accounts_section_other: 'その他',
    credit_cards_title: 'クレジットカード',
    credit_cards_add: 'カードを追加',
    credit_cards_no_result: 'クレジットカードが見つかりません',
    credit_cards_modal_add: 'カードを追加',
    credit_cards_modal_edit: 'カードを編集',
    credit_cards_form_name: 'カード名',
    credit_cards_form_name_placeholder: '例: 楽天カード',
    credit_cards_total_limit: '合計利用可能枠',
    credit_cards_used: '利用額',
    credit_cards_utilization: '利用率',
    credit_cards_available: '残り',
    // 引き落とし予定と残高不足の警告
    cpf_title: '引き落とし予定',
    cpf_subtitle: '{until} までの引き落としと、引き落とし先口座の残高見込み',
    cpf_empty: '引き落とし予定はありません。カードに引き落とし先・締め日・引き落とし日を設定すると表示されます。',
    cpf_unconfigured: '{names} は締め日・引き落とし日・引き落とし先のいずれかが未設定のため、予定を出せません。',
    cpf_balance_now: '現在残高',
    cpf_column_date: '引き落とし日',
    cpf_column_card: 'カード',
    cpf_column_account: '引き落とし先',
    cpf_column_amount: '引き落とし額',
    cpf_column_projected: '引き落とし後の残高',
    cpf_status_scheduled: '登録済み',
    cpf_status_forecast: '見込み',
    cpf_closing: '{date} 締め',
    cpf_shortfall_badge: '{amount} 不足',
    cpf_shortfall_alert: '{account} は {date} の引き落としで {amount} 不足する見込みです。',
    cpf_ok: '{until} までの引き落としは、すべて残高で足ります。',
    cpf_details: '現在残高・織り込んだ入出金・注意事項',
    cpf_source_recurring: '定期取引',
    cpf_source_scheduled: '登録済みの未来取引',
    cpf_note: '引き落とし額は締め日時点の未払残高から算出しています。カードの利用明細を取り込んでいない期間があると実際とずれます。',
    cpf_banner_link: '引き落とし予定を見る',
    accounts_member_none_group: '所有者未設定',
    // Account types
    account_type_bank_group: '銀行口座',
    account_type_checking: '普通預金',
    account_type_savings: '定期預金',
    account_type_credit_card: 'クレジットカード',
    account_type_investment: '証券口座',
    account_type_cash: '現金',
    account_type_other: 'その他',
    // Budget
    budget_title: '予算',
    budget_subtitle: '月別の予算管理',
    budget_add: '予算を追加',
    budget_copy_next: '翌月へコピー',
    budget_copy_done: '{copied}件コピーしました（{skipped}件スキップ）',
    budget_copy_error: 'コピーに失敗しました',
    budget_total_label: '合計支出 / 合計予算',
    budget_empty: '予算が設定されていません',
    budget_col_category: 'カテゴリ',
    budget_col_amount: '予算',
    budget_col_actual: '実績',
    budget_col_remaining: '残額',
    budget_col_ratio: '消化率',
    budget_col_actions: '操作',
    budget_delete_confirm: 'この予算を削除しますか？',
    budget_modal_no_categories: '追加できるカテゴリがありません',
    budget_modal_amount_label: '予算金額（円）',
    budget_modal_amount_placeholder: '例: 30000',
    budget_modal_invalid: 'カテゴリと金額を正しく入力してください',
    // Recurring
    recurring_title: '定期取引',
    recurring_subtitle: '繰り返し発生する取引の管理',
    recurring_add: '+ 定期取引を追加',
    recurring_pending_label: '今月 未処理 ({count}件):',
    recurring_pending_item: '{description}（{date}）',
    recurring_pending_separator: '、',
    recurring_generate_success: '取引を登録しました',
    recurring_generate_error: '登録に失敗しました',
    recurring_archive_confirm: 'この定期取引をアーカイブしますか？',
    recurring_empty: '定期取引がありません',
    recurring_col_name: '取引名',
    recurring_col_amount: '金額',
    recurring_col_category: 'カテゴリ',
    recurring_col_pattern: 'パターン',
    recurring_col_next: '次回予定',
    recurring_col_actions: '操作',
    recurring_archived_badge: 'アーカイブ済',
    recurring_register_today: '今日で登録',
    recurring_archive_title: 'アーカイブ',
    recurring_modal_title: '定期取引を追加',
    recurring_form_name: '取引名',
    recurring_form_name_placeholder: '例: 家賃',
    recurring_form_type: '取引種別',
    recurring_form_amount: '金額（円）',
    recurring_form_amount_placeholder: '例: 80000',
    recurring_form_category: 'カテゴリ',
    recurring_form_account: '口座',
    recurring_form_pattern: '繰り返しパターン',
    recurring_form_day_of_month: '日付（日）',
    recurring_form_day_of_week: '曜日',
    recurring_form_month: '月',
    recurring_form_reminder: 'リマインダー通知',
    recurring_form_excluded: '集計対象外にする',
    recurring_form_excluded_hint: 'ここから作られる取引を集計対象外にします。',
    recurring_pattern_monthly_fixed: '毎月（固定日）',
    recurring_pattern_monthly_last: '毎月末日',
    recurring_pattern_weekly: '毎週',
    recurring_pattern_yearly: '毎年',
    recurring_modal_invalid: 'すべての必須項目を入力してください',
    // Annual ledger
    ledger_title: '年間台帳',
    ledger_subtitle: '1年分の入出金と残高推移を横スクロールで確認できます',
    ledger_col_desc: '説明',
    ledger_col_amount: '金額',
    ledger_col_total: '合計',
    ledger_col_balance: '残高',
    ledger_opening_balance: '年初残高',
    ledger_excluded_note: '集計対象外の取引は残高には反映され、月の収入・支出の合計からは外れます。',
    ledger_closing_balance: '年末残高',
    ledger_year_income: '年間収入',
    ledger_year_expense: '年間支出',
    ledger_hide_empty: '取引のない日を隠す',
    ledger_month_empty: '取引がありません',
    ledger_search_placeholder: '説明で検索',
    ledger_search_no_match: '一致する取引がありません',
    ledger_jump_today: '今月へ',
    ledger_fetch_error: '年間台帳の取得に失敗しました',
    ledger_threshold_title: '残高の色しきい値',
    ledger_threshold_low_label: '赤にする残高（未満）',
    ledger_threshold_high_label: '緑にする残高（以上）',
    ledger_threshold_reset: '初期値に戻す',
    ledger_month_opening_balance: '月初残高',
    ledger_month_closing_balance: '月末残高',
    ledger_month_income: '月間収入',
    ledger_month_expense: '月間支出',
    // Annual matrix（ライフプラン画面の収支の区画で使う）
    matrix_col_category: '項目',
    matrix_col_annual: '年額',
    matrix_total_income: '収入合計',
    matrix_total_expense: '支出合計',
    matrix_total_transfer: '振替合計',
    matrix_net: '収支',
    matrix_savings_rate: '貯蓄率',
    matrix_heatmap: '金額を濃淡で表示',
    matrix_export_csv: 'CSV出力',
    matrix_uncategorized: '未分類',
    matrix_fetch_error: '収支表の取得に失敗しました',
    matrix_total_investment: '投資合計',
    matrix_transfer_note: '振替は資産の移動なので、収支と貯蓄率には含めていません。',
    matrix_transfer_investment_note: '振替と投資は資産の移動なので、収支と貯蓄率には含めていません。投資は証券口座の売買明細（買付 - 売却）から集計しています。',
    matrix_cumulative_investment: '投資を累計で表示',
    matrix_cumulative_investment_note: '累計表示では、投資のセルを期間の始まりからの積み上げにしています（合計は変わりません）。',
    matrix_open_transactions: 'この条件で取引一覧を開く',
    // Life plan
    lp_title: 'ライフプラン',
    lp_subtitle_month: '行=項目 / 列=月で、1年分の収支と資産の積み上げを並べます',
    lp_subtitle_year: '行=項目 / 列=年で、収支の実績と将来の金融資産残高を見通します',
    lp_unit_month: '月単位',
    lp_unit_year: '年単位',
    lp_col_item: '項目',
    lp_col_year_total: '年計',
    lp_col_year_total_hint: '収入・支出・投資額のような「その期間の額」の行は12か月の合計、残高・元本・評価損益のような「累計」の行は12月末の値です。',
    lp_balance: '金融資産残高',
    lp_final_balance: '{year}年の金融資産残高',
    lp_year_end_balance: '{year}年12月末の金融資産残高',
    lp_total_contribution: '投資額合計',
    lp_total_principal: '投資額(元本)合計',
    lp_total_principal_hint: '全枠を合わせた、その年末までに入れた投資額の累計',
    lp_bucket_contribution: '投資額：{name}',
    lp_row_principal: '投資額(元本)',
    lp_row_value: '評価額',
    lp_row_gain: '評価損益',
    lp_row_return: '利回り',
    lp_total_gain: '評価損益（全体）',
    lp_total_period_gain: '評価損益の増減（全体）',
    lp_total_gain_hint: '全枠を合わせた、その期末時点の評価額と元本の差（累計）',
    lp_period_cumulative: '累計',
    lp_period_annual: '年間',
    lp_period_month: '月間',
    lp_period_cumulative_hint: 'その年末までの積み上げ（投資額(元本)・評価額・評価損益の累計）',
    lp_period_cumulative_hint_month: 'その月末までの積み上げ（投資額(元本)・評価額・評価損益の累計）',
    lp_period_annual_hint: 'その年だけの額（その年に入れた投資額・その年の評価損益・その年の利回り）',
    lp_period_month_hint: 'その月だけの額（その月に入れた投資額・その月の評価損益・その月の利回り。年率には換算していません）',
    lp_period_legend: '項目名の横の印は、そのセルが「累計」（その年末までの積み上げ）か「年間」（その年だけの額）かを表します。',
    lp_period_legend_month: '項目名の横の印は、そのセルが「累計」（その月末までの積み上げ）か「月間」（その月だけの額）かを表します。',
    lp_total_period_gain_hint: '全枠を合わせた、その期間に増減した評価損益（残高の増加のうち拠出でない分）',
    lp_total_return: '利回り（全体）',
    lp_no_account_type: '区分なし',
    lp_no_member: '持ち主なし',
    lp_start_year: '表示開始年',
    lp_end_year: '表示終了年',
    lp_show_returns: '利回りを表示',
    lp_edit_assumption: '前提を編集',
    lp_modal_title: '{name} の前提',
    lp_annual_amount: '年間拠出額（円）',
    lp_return_rate: '期待利回り（％/年）',
    lp_return_rate_hint: '来年以降の評価額をこの利回りで積み上げます。空欄なら 0% で計算します。',
    lp_contribution_end_date: '拠出をやめる日',
    lp_contribution_end_date_hint: '空欄なら表の右端まで拠出し続けます。年の途中で止める場合、その年は月割りになります（6月末なら年間拠出額の6/12）。',
    lp_pivot: '{year}年末（現在の保有データ）',
    lp_pivot_detail: '元本 {principal} / 評価額 {value}',
    lp_actual_return: '通算の実績利回り {rate}%',
    lp_scheme_nisa: 'NISA（つみたて投資枠・成長投資枠）',
    lp_scheme_nisa_tsumitate: 'NISA つみたて投資枠',
    lp_scheme_nisa_growth: 'NISA 成長投資枠',
    lp_scheme_kodomo_nisa: 'こどもNISA（2027年開始予定）',
    lp_scheme_nisa_old_tsumitate: 'つみたてNISA（旧制度）',
    lp_scheme_nisa_old_general: '一般NISA（旧制度）',
    lp_scheme_junior_nisa: 'ジュニアNISA（旧制度）',
    lp_scheme_ideco: 'iDeCo',
    lp_scheme_kyosai: '小規模企業共済',
    lp_scheme_unknown: '拠出枠の定めなし',
    lp_limit_annual: '年間投資枠 {amount}',
    lp_limit_annual_varies: '年間投資枠 {amount}（加入区分により異なります）',
    lp_limit_annual_none: '年間投資枠の定めはありません',
    lp_limit_lifetime: '非課税保有限度額 {limit}（残り {remaining}）',
    lp_limit_group_note: 'NISA の非課税保有限度額は、同じ人のつみたて投資枠・成長投資枠・こどもNISAで分け合います（成長投資枠は内枠1,200万円、こどもNISAは内枠600万円まで）。こどもNISAの分は18歳で成人のNISAに引き継がれます。',
    lp_limit_age: '拠出できるのは、その年の1月1日時点で持ち主が{age}歳未満のあいだだけです（生年月日が未登録の枠は抑えません）。',
    lp_limit_closed: 'この制度は新規の拠出が終了しています。将来の拠出は 0 として計算します。',
    lp_limit_error_annual: '年間投資枠（{amount}）を超えています。',
    lp_limit_filled: '{year}年に非課税保有限度額に達するため、それ以降の拠出は 0 になります',
    lp_actual_return_none: '通算の実績利回りは算出できません（売買明細がありません）',
    lp_empty: '取引も投資商品もまだありません。取引を登録すると収支が、投資画面で証券会社と保有商品を登録すると預り区分ごとの枠と資産の見通しがここに並びます。',
    lp_month_forecast_note: '経過した月は売買明細からの実績で、まだ来ていない月は年間拠出額の月割りと期待利回りの月複利での見通しです（今年の残りの月は非課税保有限度額を当てていません）。',
    lp_export_csv: 'CSV出力',
    lp_fetch_error: 'ライフプランの取得に失敗しました',
    lp_unpriced_note: '基準価額が未取得の商品が {count} 件あります。その分の評価額は取得金額で代替しています。',
    lp_note: '{year}年までは売買明細からの実績です（各年末の評価額は、その年までの保有数量にその時点の約定単価を当てて再現しています。利回りは年内の拠出を期央とみなす Modified Dietz 法）。{year}年の列は現在の保有データそのままで、翌年からは枠ごとの期待利回りと年間拠出額での見通しです。将来の拠出は制度の枠に収めます（NISA は年間投資枠がつみたて120万円・成長240万円・こどもNISA60万円、非課税保有限度額1,800万円を同じ人の枠で分け合い、成長投資枠は内枠1,200万円・こどもNISAは内枠600万円まで。こどもNISAは持ち主が18歳になる年から拠出なし。旧制度とジュニアNISAは新規拠出なし）。税・手数料は考慮していません。',
    // Reports
    reports_title: 'レポート',
    reports_view_monthly: '月間',
    reports_view_annual: '年間',
    reports_year_label: '{year}年',
    reports_trend_title_daily: '日別収支推移（{year}年{month}月）',
    reports_jump_current_month: '今月',
    reports_jump_current_year: '今年',
    reports_trend_title_annual: '月別収支推移（{year}年）',
    reports_category_title: 'カテゴリ別支出',
    reports_category_detail_title: 'カテゴリ別支出明細',
    reports_no_data: 'データがありません',
    reports_col_category: 'カテゴリ',
    reports_col_amount: '金額',
    reports_col_ratio: '割合',
    reports_open_transactions: 'このカテゴリ・期間で取引一覧を開く',
    reports_income: '収入',
    reports_expense: '支出',
    reports_balance: '差引',
    reports_tooltip_income_label: '収入：{amount}',
    reports_tooltip_expense_label: '支出：{amount}',
    reports_tooltip_balance_label: '差引：{amount}',
    // Auth
    auth_login_title: 'ログイン',
    auth_login_submit: 'ログイン',
    auth_login_submitting: 'ログイン中...',
    auth_login_error: 'ログインに失敗しました',
    auth_register_title: 'アカウント作成',
    auth_register_submit: 'アカウントを作成',
    auth_register_submitting: '登録中...',
    auth_register_error: '登録に失敗しました',
    auth_email: 'メールアドレス',
    auth_password: 'パスワード',
    auth_display_name: '表示名',
    auth_password_hint: '8文字以上・英数字混在',
    auth_show_password: 'パスワードを表示する',
    auth_hide_password: 'パスワードを隠す',
    auth_no_account: 'アカウントをお持ちでない方は',
    auth_have_account: 'すでにアカウントをお持ちの方は',
    auth_to_register: '新規登録',
    auth_to_login: 'ログイン',
    // Institution combobox
    institution_no_result: '該当なし',
    member_no_result: '該当なし',
    // Category combobox
    category_search_placeholder: 'カテゴリを検索',
    // Searchable select
    select_search_placeholder: '検索',
    select_no_result: '該当なし',
    select_multi_summary: '{label} 他{count}件',
  },
  en: {
    // Navigation
    nav_dashboard: 'Dashboard',
    nav_reports: 'Reports',
    nav_calendar: 'Calendar',
    nav_transactions: 'Transactions',
    nav_accounts: 'Accounts',
    nav_credit_cards: 'Credit Cards',
    nav_budget: 'Budget',
    nav_recurring: 'Recurring',
    nav_investments: 'Investments',
    nav_balance: 'Balance',
    nav_life_plan: 'Life plan',
    // Investments
    inv_title: 'Investment Accounts',
    inv_subtitle: 'Holdings and market value by investment account',
    inv_total_market_value: 'Market value',
    inv_total_cost: 'Cost basis',
    inv_total_cost_sum: 'Total cost basis',
    inv_total_gain_loss: 'Unrealized gain/loss',
    inv_price_auto_updated: 'Prices update daily at 21:00 JST (last updated {datetime})',
    inv_price_auto_updated_never: 'Prices update daily at 21:00 JST',
    inv_day_change: 'Day change',
    inv_add_brokerage: '+ Add account',
    inv_brokerage_name: 'Account name',
    inv_brokerage_name_hint: 'Change it when you keep several accounts at the same brokerage (defaults to the brokerage name).',
    inv_brokerage_institution: 'Brokerage',
    inv_brokerage_modal_add: 'Add investment account',
    inv_brokerage_modal_edit: 'Edit investment account',
    inv_brokerage_delete_confirm: 'Delete "{name}"? Its holdings and linked account will also be deleted.',
    inv_no_brokerages: 'No investment accounts yet. Add one to get started.',
    inv_unlinked_accounts: 'Investment accounts without holdings',
    inv_unlinked_accounts_hint: 'These accounts have no brokerage details linked. Accounts tracked by balance only appear here.',
    inv_import_csv: 'Import CSV',
    inv_importing: 'Importing...',
    inv_import_result: 'Imported {imported} trade(s) ({skipped} duplicates skipped)',
    inv_import_hint: 'Supports Rakuten Securities mutual fund trade history CSV and SBI Securities iDeCo trade history CSV.',
    inv_add_product: '+ Add product',
    inv_product_modal_add: 'Add product',
    inv_product_modal_edit: 'Edit product',
    inv_product_name: 'Product name',
    inv_product_category: 'Asset category',
    inv_product_quantity: 'Quantity',
    inv_product_account_type: 'Account type',
    inv_product_account_type_hint: 'e.g. Tsumitate NISA, NISA growth quota, taxable. The same product is tracked separately per account type.',
    inv_product_fund_cd: 'Fund code',
    inv_product_fund_cd_hint: 'JITA association fund code. Setting it fetches the NAV automatically (Mitsubishi UFJ AM funds only).',
    inv_product_cost: 'Cost basis',
    inv_product_delete_confirm: 'Delete "{name}"? Imported trades will also be deleted.',
    inv_no_products: 'No holdings yet. Import a CSV or add a product.',
    inv_col_product: 'Product',
    inv_col_account_type: 'Account type',
    inv_col_quantity: 'Quantity',
    inv_col_price: 'NAV',
    inv_col_market_value: 'Market value',
    inv_col_cost: 'Cost',
    inv_col_gain_loss: 'Gain/loss',
    inv_account_type_none: 'Unspecified',
    inv_account_type_breakdown: 'By account type',
    inv_account_type_breakdown_rest: 'Other',
    inv_account_type_breakdown_empty: 'No holdings with a known price yet.',
    inv_price_unavailable: 'Unavailable',
    inv_price_as_of: 'as of {date}',
    inv_unpriced_warning: '{count} product(s) have no price yet. Set a fund code or enter the NAV manually.',
    inv_category_equity_fund: 'Equity mutual fund',
    inv_category_bond_fund: 'Bond mutual fund',
    inv_category_domestic_stock: 'Domestic stock',
    inv_category_foreign_stock: 'Foreign stock',
    inv_category_etf: 'ETF',
    inv_category_reit: 'REIT',
    inv_category_bond: 'Bond',
    inv_category_other: 'Other',
    nav_settings: 'Settings',
    nav_logout: 'Logout',
    nav_collapse_sidebar: 'Collapse sidebar',
    nav_expand_sidebar: 'Expand sidebar',
    // Settings
    settings_title: 'Settings',
    tab_categories: 'Categories',
    tab_csv: 'Import/Export',
    tab_security: 'Security',
    tab_language: 'Language',
    tab_appearance: 'Appearance',
    tab_members: 'Members',
    tab_integrations: 'Integrations',
    // Wise integration
    wise_title: 'Wise Integration',
    wise_desc: 'Connect your Wise account with a personal token to import balances and transactions automatically.',
    wise_token_note: 'Issuing a read-only token on the Wise side is recommended.',
    wise_token_placeholder: 'Enter personal token',
    wise_connect_btn: 'Connect',
    wise_connecting: 'Connecting...',
    wise_connections_title: 'Connected profiles',
    wise_no_connections: 'No Wise accounts connected yet',
    wise_delete: 'Disconnect',
    wise_delete_confirm: 'Disconnect "{name}"? Imported transactions will be kept.',
    wise_balances_title: 'Wise balances',
    wise_balances_empty: 'No balances found',
    wise_link_btn: 'Add as account',
    wise_linking: 'Adding...',
    wise_linked_badge: 'Linked',
    wise_sync_btn: 'Sync',
    wise_sync_full_btn: 'All time',
    wise_syncing: 'Syncing...',
    wise_last_synced: 'Last synced',
    wise_never_synced: 'Not synced yet',
    wise_sync_result: 'Imported {imported} transactions ({updated} updated / {skipped} already imported)',
    appearance_title: 'Theme',
    appearance_system: 'System',
    appearance_light: 'Light',
    appearance_dark: 'Dark',
    amount_unit_title: 'Amount unit',
    amount_unit_desc: 'Switch the scale of amounts in lists and charts. Amounts under 10,000 JPY stay in yen, and 100 million or more is grouped with 億.',
    amount_unit_yen: 'Yen (¥1,234,567)',
    amount_unit_man: 'Man-yen / 10k JPY (123.5万円 / 1億5400.5万円)',
    // Members
    members_desc: 'Register the people who own your assets. Assign an owner to each account to see assets per person on the dashboard.',
    members_add: '+ Add',
    members_edit: 'Edit',
    members_delete: 'Delete',
    members_delete_confirm: 'Delete "{name}"?',
    members_empty: 'No members registered',
    members_accounts_count: '{count} accounts',
    member_modal_add: 'Add Member',
    member_modal_edit: 'Edit Member',
    member_name_label: 'Name',
    member_name_placeholder: 'e.g. Taro',
    member_birth_date_label: 'Date of Birth',
    member_birth_date_hint: 'Optional. Enter it to show the age in the list.',
    member_age_display: '{age} years old',
    member_color_label: 'Color',
    // Category
    categories_custom: 'Custom Categories',
    categories_default: 'Default Categories',
    categories_add: '+ Add',
    categories_edit: 'Edit',
    categories_delete: 'Delete',
    categories_delete_confirm: 'Delete "{name}"?',
    categories_empty: 'No custom categories',
    categories_default_badge: 'Default',
    category_modal_add: 'Add Category',
    category_modal_edit: 'Edit Category',
    category_icon_label: 'Icon (emoji)',
    category_name_label: 'Name',
    category_type_label: 'Type',
    category_color_label: 'Color',
    type_expense: 'Expense',
    type_income: 'Income',
    type_transfer: 'Transfer',
    // CSV
    csv_export_title: 'CSV Export',
    csv_export_desc: 'Download all transaction data as a CSV file.',
    csv_export_btn: 'Download CSV',
    csv_exporting: 'Exporting...',
    csv_import_title: 'CSV Import',
    csv_import_desc: 'Bulk import transactions from CSV files. Multiple files can be selected at once.',
    csv_import_btn: 'Select CSV files',
    csv_importing: 'Importing...',
    csv_import_format_label: 'CSV format',
    csv_format_generic: 'Generic format',
    csv_format_rakuten: 'Rakuten Card',
    csv_format_paypay_card: 'PayPay Card',
    csv_format_view_card: 'VIEW Card',
    csv_format_smbc_card: 'Sumitomo Mitsui Card',
    csv_format_sbi_net_bank: 'Docomo SMTB Net Bank',
    csv_format_gmo_aozora_bank: 'GMO Aozora Net Bank',
    csv_format_rakuten_bank: 'Rakuten Bank',
    csv_format_paypay_bank: 'PayPay Bank',
    csv_import_account_label: 'Target account',
    csv_import_account_placeholder: 'Select an account',
    csv_import_select_account_error: 'Please select the target account',
    csv_import_account_no_match: 'No account matches the selected format. You can pick from all accounts, but setting the account\u2019s financial institution narrows the list next time.',
    csv_import_rakuten_note: 'Supports the statement CSV (Shift-JIS) downloaded from Rakuten e-NAVI. Categories are inferred from the merchant name, falling back to "Other" when no match is found. Re-importing the same statement automatically skips duplicates.',
    csv_import_paypay_card_note: 'Supports the statement CSV (UTF-8) downloaded from the PayPay Card member menu. Amounts use the total payment including fees, and negative rows (cancellations and refunds) are imported as income. Categories are inferred from the merchant name, falling back to "Other" when no match is found. Installment/revolving payment types and fees are recorded in the note. Re-importing the same statement automatically skips duplicates.',
    csv_import_view_card_note: 'Supports the statement CSV (Shift-JIS) downloaded from VIEW\'s NET. Amounts use the billed amount including fees and interest, and refunds/cancellations are imported as income. Categories are inferred from the usage location (Suica auto-charge is treated as transport), falling back to "Other" when no match is found. Payment types other than single payment and foreign-currency amounts are recorded in the note. Re-importing the same statement automatically skips duplicates.',
    csv_import_smbc_card_note: 'Supports the statement CSV (Shift-JIS) downloaded from Vpass. Categories are inferred from the merchant name, falling back to "Other" when no match is found. Payment counts other than single payment and the remarks column are recorded in the note. Re-importing the same statement automatically skips duplicates.',
    csv_import_sbi_net_bank_note: 'Supports the transaction statement CSV (Shift-JIS) downloaded from Docomo SMTB Net Bank (NEOBANK). Withdrawals are imported as expenses and deposits as income, with categories inferred from the description. The balance column is ignored (the account balance is updated from the imported transactions). Re-importing the same statement automatically skips duplicates.',
    csv_import_gmo_aozora_bank_note: 'Supports the transaction statement CSV (Shift-JIS) downloaded from GMO Aozora Net Bank. Dates in the separator-less 8-digit form (YYYYMMDD) are handled; withdrawals are imported as expenses and deposits as income. Categories are inferred from the description, and Pay-easy tax payments (e.g. "PE Tachikawa Tax Office") fall back to "Other". The balance column is ignored (the account balance is updated from the imported transactions). Re-importing the same statement automatically skips duplicates.',
    csv_import_rakuten_bank_note: 'Supports the transaction statement CSV (Shift-JIS) downloaded from Rakuten Bank. Dates use the separator-less 8-digit form (YYYYMMDD) and a single signed amount column, so negative rows are imported as expenses and positive rows as income. Categories are inferred from the description; katakana tax/public payments (e.g. "SHIMINZEI") and transfers to other banks fall back to "Other". The balance column is ignored (the account balance is updated from the imported transactions). Re-importing the same statement automatically skips duplicates.',
    csv_import_paypay_bank_note: 'Supports the transaction statement CSV (Shift-JIS) downloaded from PayPay Bank. Dates are split across separate year/month/day columns; the "payment" column is imported as expenses and the "deposit" column as income. Categories are inferred from the description: Visa debit purchases (which carry no merchant name), katakana tax/public payments (e.g. the Pay-easy entry "PE HIGASHIMURAYAMA ZEIMUSHO"), and transfers to other banks fall back to "Other", while account interest and Visa debit cashback become "Other income". The transaction time and per-day sequence number are ignored (Zeni transactions are date-based), as is the balance column (the account balance is updated from the imported transactions). Re-importing the same statement automatically skips duplicates.',
    csv_import_file_no_rows: 'No importable rows found in {name}',
    // Security
    security_reset_title: 'Password Reset',
    security_reset_desc: 'Send a reset link to your registered email address.',
    security_email_placeholder: 'Email address',
    // Language
    language_title: 'Display Language',
    language_ja: '日本語',
    language_en: 'English',
    // Common
    common_save: 'Save',
    common_saving: 'Saving...',
    common_cancel: 'Cancel',
    common_send: 'Send',
    common_sending: 'Sending...',
    common_loading: 'Loading...',
    common_save_error: 'Failed to save',
    common_delete_error: 'Failed to delete',
    common_send_error: 'Failed to send',
    common_fetch_error: 'Failed to fetch',
    common_update_error: 'Failed to update',
    common_edit: 'Edit',
    common_add: 'Add',
    common_delete: 'Delete',
    common_today: 'Today',
    common_no_data: 'No data',
    common_not_set: 'Not set',
    common_year_month: '{month}/{year}',
    common_year_month_day: '{month}/{day}/{year}',
    common_month_n: 'M{n}',
    common_day_sun: 'Sun',
    common_day_mon: 'Mon',
    common_day_tue: 'Tue',
    common_day_wed: 'Wed',
    common_day_thu: 'Thu',
    common_day_fri: 'Fri',
    common_day_sat: 'Sat',
    // Dashboard
    dashboard_title: 'Dashboard',
    dashboard_subtitle: 'Financial overview',
    dashboard_total_assets: 'Total Assets',
    dashboard_daily_change: 'vs Yesterday',
    dashboard_market_title: 'Market',
    dashboard_market_sp500: 'S&P 500',
    dashboard_market_usdjpy: 'USD/JPY',
    dashboard_market_error: 'Failed to load market data',
    dashboard_econ_title: 'Japanese Economic Indicators',
    dashboard_econ_error: 'Failed to load economic indicators',
    dashboard_econ_about: 'About these indicators',
    dashboard_econ_about_body: 'Official government statistics, shown as published. They are released monthly or quarterly, so the values change only a few times a month.',
    dashboard_econ_change: 'vs previous',
    econ_MONTHLY_ECONOMIC_REPORT: 'Monthly Economic Report (assessment)',
    econ_GDP_REAL_ANNUALIZED: 'Real GDP growth (QoQ annualized)',
    econ_BUSINESS_CI_COINCIDENT: 'Business conditions (coincident CI)',
    econ_BUSINESS_CI_LEADING: 'Business conditions (leading CI)',
    econ_WATCHER_CURRENT_DI: 'Economy Watchers: current DI',
    econ_WATCHER_OUTLOOK_DI: 'Economy Watchers: outlook DI',
    econ_CPI_ALL: 'CPI all items (YoY)',
    econ_CPI_CORE: 'CPI core (YoY)',
    econ_REAL_WAGE_YOY: 'Real wage index (YoY)',
    econ_UNEMPLOYMENT_RATE: 'Unemployment rate (SA)',
    econ_JOB_OPENINGS_RATIO: 'Jobs-to-applicants ratio (SA)',
    dashboard_month_income: 'Income',
    dashboard_month_expense: 'Expense',
    dashboard_month_balance: 'Balance',
    dashboard_recent_tx: 'Recent Transactions',
    dashboard_no_tx: 'No transactions',
    dashboard_asset_trend: 'Asset Trend',
    dashboard_asset_trend_months: '{n} months',
    dashboard_asset_composition: 'Asset Breakdown',
    dashboard_asset_share: '{percent}% of total assets',
    dashboard_member_assets: 'Assets by Member',
    dashboard_member_unassigned: 'Unassigned',
    dashboard_member_share: '{percent}% of total assets',
    dashboard_member_assets_empty: 'Add members in Settings and assign owners to accounts to see assets per person.',
    dashboard_goal_title: 'Goal Progress',
    dashboard_goal_pace_label: 'At this pace',
    dashboard_goal_days: '{days} days to go',
    dashboard_goal_years: 'About {years} years to go',
    dashboard_goal_over_years: 'More than {years} years at this pace',
    dashboard_goal_achieved: 'Goal reached',
    dashboard_goal_pace_label_decreasing: 'Asset change per month',
    dashboard_goal_pace_monthly: '{amount} / month',
    dashboard_goal_estimated_date: 'around {date}',
    dashboard_goal_confidence: '{percent}% confidence',
    dashboard_goal_outlook_short: '{amount} in {years} years',
    dashboard_goal_basis: 'How this is estimated',
    dashboard_goal_basis_pace: 'Asset trend (last {months} months)',
    dashboard_goal_basis_cashflow: 'Average monthly net (reference)',
    dashboard_goal_basis_fit: 'Fit to a straight line (R²)',
    dashboard_goal_basis_deviation: 'Month-to-month spread (±)',
    dashboard_goal_basis_outlook: 'Projection in {years} years',
    dashboard_goal_basis_range: '95% range {low} - {high}',
    dashboard_goal_basis_note: 'A least-squares line is fitted to your total assets over the last {months} months ({points} points), and its slope is extended from today\'s total. Confidence is that fit (R²) discounted by how far ahead the estimate reaches; it does not account for market swings or one-off income and expenses.',
    dashboard_goal_remaining: 'Remaining',
    dashboard_goal_target: 'Goal',
    dashboard_goal_empty: 'Set a goal amount to see how long it will take to reach it.',
    dashboard_goal_set: 'Set goal amount',
    dashboard_goal_edit: 'Edit goal amount',
    dashboard_goal_amount_label: 'Target total assets',
    dashboard_goal_amount_hint: 'Estimated from how your assets grew over the last {months} months.',
    dashboard_goal_delete: 'Remove goal',
    dashboard_goal_delete_confirm: 'Remove the goal amount?',
    // Transactions
    transactions_title: 'Transactions',
    transactions_subtitle: 'Manage your income and expenses',
    transactions_add: 'Add Transaction',
    transactions_modal_title: 'Add Transaction',
    transactions_modal_edit_title: 'Edit Transaction',
    transactions_delete: 'Delete',
    transactions_delete_confirm: 'Delete this transaction?',
    transactions_no_result: 'No transactions found',
    transactions_csv_export: 'Export CSV',
    transactions_csv_exporting: 'Exporting...',
    transactions_filter_all_accounts: 'All Accounts',
    transactions_filter_all_to_accounts: 'All Destinations',
    transactions_filter_all_types: 'All Types',
    transactions_filter_all_categories: 'All Categories',
    transactions_filter_search: 'Search description or note',
    // Date range picker
    date_range_placeholder: 'Select period',
    date_range_pick_start: 'Pick a start date',
    date_range_pick_end: 'Pick an end date',
    date_range_this_month: 'This month',
    date_range_last_month: 'Last month',
    date_range_this_year: 'This year',
    date_range_last_30_days: 'Last 30 days',
    date_range_clear: 'Clear',
    date_range_prev_month: 'Previous month',
    date_range_next_month: 'Next month',
    // Amount range picker
    amount_range_placeholder: 'Amount range',
    amount_range_min: 'Min (JPY)',
    amount_range_max: 'Max (JPY)',
    amount_range_no_limit: 'No limit',
    amount_range_hint: 'Either bound is optional',
    amount_range_preset_under_10k: 'Under 10,000',
    amount_range_preset_10k_50k: '10,000 - 50,000',
    amount_range_preset_50k_100k: '50,000 - 100,000',
    amount_range_preset_over_100k: 'Over 100,000',
    amount_range_target: 'Applies to',
    amount_range_target_both: 'Both income and expense',
    amount_range_target_all: 'All types when unchecked',
    amount_range_target_transfer_only: 'Transfers only',
    amount_range_clear: 'Clear',
    amount_range_apply: 'Apply',
    transactions_col_date: 'Date',
    transactions_col_description: 'Description',
    transactions_col_category: 'Category',
    transactions_col_type: 'Type',
    transactions_col_account: 'Account',
    transactions_col_amount: 'Amount',
    transactions_pagination: '{total} items / Page {page} of {totalPages}',
    transactions_prev: 'Previous',
    transactions_next: 'Next',
    transactions_per_page: 'per page',
    transactions_summary_count: 'Count',
    transactions_summary_expense: 'Total expense',
    transactions_summary_income: 'Total income',
    transactions_summary_transfer: 'Total transfers',
    transactions_summary_net: 'Net',
    transactions_summary_average: 'Average',
    transactions_summary_unit: '{count} items',
    transactions_summary_truncated: 'Aggregated over the first {count} items due to a large result set',
    transactions_summary_selected_note: 'Aggregated over the {count} selected transactions only',
    transactions_form_type: 'Type',
    transactions_form_date: 'Date',
    transactions_form_description: 'Description',
    transactions_form_description_placeholder: 'e.g. Grocery shopping',
    transactions_form_category: 'Category',
    transactions_form_amount: 'Amount',
    transactions_form_account: 'Account',
    transactions_form_account_placeholder: 'Select account',
    transactions_form_from_account: 'From account',
    transactions_form_to_account: 'To account',
    transactions_form_to_account_placeholder: 'Select destination account',
    transactions_form_to_account_hint: 'The amount is deducted from the source account and added to the destination (restoring available credit for credit cards). Transfers are excluded from income and expense totals.',
    transactions_form_to_account_required: 'Please select a destination account',
    transactions_form_account_required: 'Please select an account',
    transactions_filter_search_accounts: 'Search accounts',
    transactions_filter_search_to_accounts: 'Search destinations',
    transactions_filter_clear: 'Clear filters',
    // Transfer direction (from → to)
    transactions_transfer_from_label: 'From',
    transactions_transfer_to_label: 'To',
    transactions_transfer_unselected: 'Not selected',
    transactions_transfer_mixed_accounts: '{count} accounts',
    transactions_transfer_mixed_types: 'Mixed types',
    transactions_transfer_from_hint: 'Destinations commonly used when the source is {type} are listed first.',
    transactions_transfer_from_unknown_hint: 'Pick the source account first and the destinations will be narrowed down.',
    transactions_transfer_mixed_hint: 'The selected transactions have source accounts of different types, so the destinations cannot be narrowed down.',
    transactions_form_to_account_group_others: 'Other accounts',
    transactions_form_to_account_show_all: 'Choose from all accounts',
    transactions_form_to_account_no_option: 'No account is available as a destination',
    // What each source/destination combination means
    transfer_pattern_card_payment: 'Credit card payment',
    transfer_pattern_card_payment_desc: 'Charged from {from}, restoring the same amount of available credit on {to}.',
    transfer_pattern_between_banks: 'Move money between accounts',
    transfer_pattern_between_banks_desc: '{from} decreases and {to} increases by the same amount. Net worth is unchanged.',
    transfer_pattern_withdrawal: 'Cash withdrawal',
    transfer_pattern_withdrawal_desc: '{from} decreases and the cash in {to} increases by the same amount.',
    transfer_pattern_deposit: 'Deposit into an account',
    transfer_pattern_deposit_desc: 'The cash in {from} decreases and {to} increases by the same amount.',
    transfer_pattern_investing: 'Deposit into an investment account',
    transfer_pattern_investing_desc: '{from} decreases and {to} increases by the same amount.',
    transfer_pattern_divestment: 'Withdrawal from an investment account',
    transfer_pattern_divestment_desc: '{from} decreases and {to} increases by the same amount.',
    transfer_pattern_cash_advance: 'Cash advance from a card',
    transfer_pattern_cash_advance_desc: '{to} increases and the outstanding balance on {from} grows by the same amount.',
    transfer_pattern_generic: 'Transfer between accounts',
    transfer_pattern_generic_desc: 'The amount deducted from {from} is added to {to}.',
    transactions_transfer_excluded_note: 'Transfers are excluded from income and expense totals.',
    // Cross-check for the counterpart transaction on the destination account
    transactions_transfer_counterpart_checking: 'Looking for the matching transaction…',
    transactions_transfer_counterpart_found: 'Found {count} matching transaction(s)',
    transactions_transfer_counterpart_none: 'No matching transaction on the destination account',
    transactions_transfer_counterpart_none_hint: 'No incoming transaction of the same amount was found on the destination account between {from} and {to}. Check the date, amount and destination (you can still save).',
    transactions_transfer_counterpart_via: 'transfer from {account}',
    transactions_transfer_counterpart_error: 'Could not check for the matching transaction',
    transactions_transfer_counterpart_link_none: 'Do not link',
    transactions_transfer_counterpart_link_hint: 'Pick the incoming transaction to use as the receiving side. It becomes a "transfer" so the destination balance is not counted twice. Check the description — a different payment of the same amount looks identical here.',
    transactions_transfer_counterpart_already_linked: 'already linked',
    transactions_counterpart_linked_title: 'Receiving side of a transfer from {account}',
    transactions_counterpart_linked_hint: 'This transaction is already accounted for by the transfer record, so it affects neither the account balance nor the totals. Unlink it if the match is wrong.',
    transactions_counterpart_unlink: 'Unlink and turn back into income',
    transactions_counterpart_unlinking: 'Unlinking…',
    transactions_excluded_badge: 'Excluded',
    transactions_excluded_badge_title: 'Excluded from totals (still affects the balance)',
    transactions_excluded_note: '{count} excluded transactions are left out of the income and expense totals.',
    transactions_filter_excluded_all: 'Including excluded',
    transactions_filter_excluded_exclude: 'Without excluded',
    transactions_filter_excluded_only: 'Excluded only',
    transfer_pattern_unusual: 'Unusual combination',
    transfer_pattern_unusual_desc: 'A transfer from {from} ({fromType}) to {to} ({toType}) is unusual. Check whether the source and destination are the wrong way round.',
    transactions_form_excluded: 'Exclude from totals',
    transactions_form_excluded_hint: 'Keeps affecting the account balance but is left out of income/expense, category breakdowns and budgets. Use it for things like fund purchases charged to a credit card.',
    transactions_form_note: 'Note',
    transactions_form_note_placeholder: 'Optional note',
    transactions_bulk_selected: '{count} selected',
    transactions_bulk_select_all: 'Select all',
    transactions_bulk_clear: 'Clear selection',
    transactions_bulk_edit: 'Bulk edit',
    transactions_bulk_delete: 'Bulk delete',
    transactions_bulk_delete_confirm: 'Delete the {count} selected transactions? This cannot be undone.',
    transactions_bulk_modal_title: 'Edit {count} transactions',
    transactions_bulk_keep: 'Keep unchanged',
    transactions_bulk_no_change: 'Choose at least one field to change',
    transactions_bulk_hint: 'Only the fields you set are overwritten on the selected transactions. Account and amount are left as they are.',
    transactions_bulk_excluded_label: 'Exclude from totals',
    transactions_bulk_excluded_on: 'Exclude from totals',
    transactions_bulk_excluded_off: 'Include in totals',
    transactions_bulk_updated: 'Updated {count} transactions',
    transactions_bulk_deleted: 'Deleted {count} transactions',
    transactions_csv_invalid_header: 'Invalid CSV header. Required columns: date, type, category, description, amount, accountId.',
    transactions_csv_no_rows: 'No importable rows found',
    transactions_csv_imported: '{count} transactions imported',
    transactions_csv_imported_result: 'Imported {count} transactions ({skipped} skipped as duplicates)',
    // Accounts
    accounts_title: 'Accounts',
    accounts_total_balance: 'Total Balance',
    accounts_add: 'Add Account',
    accounts_show_archived: 'Show archived',
    accounts_reorder: 'Reorder',
    accounts_reorder_done: 'Done reordering',
    accounts_reorder_hint: 'Drag a card, or use the ← → buttons, to change the order. Cards only move within the same group.',
    accounts_reorder_move_prev: 'Move earlier',
    accounts_reorder_move_next: 'Move later',
    accounts_reorder_error: 'Could not save the order',
    accounts_card_view_transactions: 'View transactions for this account',
    accounts_card_balance: 'Balance',
    accounts_no_result: 'No accounts found',
    accounts_modal_add: 'Add Account',
    accounts_modal_edit: 'Edit Account',
    accounts_form_name: 'Account Name',
    accounts_form_name_placeholder: 'e.g. Main Bank',
    accounts_form_type: 'Type',
    accounts_form_type_locked: 'The type cannot be changed after creation',
    accounts_form_balance: 'Initial Balance',
    accounts_form_card_brand: 'Card Brand',
    accounts_form_card_brand_none: 'None',
    accounts_form_credit_limit: 'Credit Limit',
    accounts_form_payment_account: 'Payment Account',
    accounts_form_payment_account_none: 'None',
    accounts_form_closing_day: 'Closing Day',
    accounts_form_payment_day: 'Payment Day',
    accounts_form_payment_month: 'Payment Month',
    accounts_form_payment_month_same: 'Same month',
    accounts_form_payment_month_next: 'Next month',
    accounts_form_payment_month_after_next: 'Month after next',
    accounts_form_day_unset: 'Not set',
    accounts_form_day_end_of_month: 'End of month',
    accounts_form_day_nth: 'Day {day}',
    accounts_form_billing_cycle_hint: 'Set the closing and payment days to check in advance whether the account will have enough on the payment date. "End of month" is rounded to the last day of each month automatically.',
    accounts_card_billing_cycle: 'Closes {closing}, paid {month} on {payment}',
    accounts_card_billing_cycle_label: 'Closing / payment day',
    accounts_form_member: 'Owner',
    accounts_form_member_none: 'Unassigned',
    accounts_form_member_hint: 'Add members in Settings to choose an owner.',
    accounts_card_overpaid_warning: 'Payments exceed recorded card charges',
    accounts_card_overpaid_hint: 'When payments for periods without imported card statements are recorded as transfers, the card balance turns positive and total assets are overstated. Change those payments back to expenses.',
    accounts_form_institution: 'Institution',
    accounts_form_institution_placeholder: 'e.g. Chase Bank',
    accounts_form_color: 'Color',
    accounts_status_active: 'Active',
    accounts_status_archived: 'Archived',
    accounts_archive: 'Archive',
    accounts_unarchive: 'Unarchive',
    accounts_delete_confirm: 'Permanently delete "{name}"? This cannot be undone. Accounts with transactions cannot be deleted.',
    accounts_deleting: 'Deleting...',
    accounts_csv_import: 'Import CSV',
    accounts_csv_import_title: 'CSV import: {name}',
    accounts_csv_import_format_placeholder: 'Select a format',
    accounts_csv_import_no_format: 'No CSV format matches this account',
    accounts_section_bank: 'Bank Accounts',
    accounts_section_investment: 'Investment Accounts',
    accounts_section_cash: 'Cash',
    accounts_section_other: 'Other',
    credit_cards_title: 'Credit Cards',
    credit_cards_add: 'Add Card',
    credit_cards_no_result: 'No credit cards found',
    credit_cards_modal_add: 'Add Card',
    credit_cards_modal_edit: 'Edit Card',
    credit_cards_form_name: 'Card Name',
    credit_cards_form_name_placeholder: 'e.g. Rakuten Card',
    credit_cards_total_limit: 'Total Credit Limit',
    credit_cards_used: 'Used',
    credit_cards_utilization: 'Utilization',
    credit_cards_available: 'Available',
    // Upcoming card payments and shortfall warnings
    cpf_title: 'Upcoming Payments',
    cpf_subtitle: 'Payments through {until} and the projected balance of each payment account',
    cpf_empty: 'No upcoming payments. Set a payment account, closing day and payment day on a card to see them here.',
    cpf_unconfigured: '{names}: no forecast because the closing day, payment day or payment account is not set.',
    cpf_balance_now: 'Current balance',
    cpf_column_date: 'Payment date',
    cpf_column_card: 'Card',
    cpf_column_account: 'From account',
    cpf_column_amount: 'Amount',
    cpf_column_projected: 'Balance after payment',
    cpf_status_scheduled: 'Recorded',
    cpf_status_forecast: 'Forecast',
    cpf_closing: 'Closes {date}',
    cpf_shortfall_badge: '{amount} short',
    cpf_shortfall_alert: '{account} is projected to be {amount} short for the payment on {date}.',
    cpf_ok: 'Every payment through {until} is covered by the projected balance.',
    cpf_details: 'Current balances, included cash flow and notes',
    cpf_source_recurring: 'Recurring',
    cpf_source_scheduled: 'Future-dated transaction',
    cpf_note: 'Amounts are derived from the unpaid balance as of each closing date. Periods with no imported card statements will differ from the real bill.',
    cpf_banner_link: 'View upcoming payments',
    accounts_member_none_group: 'No owner',
    // Account types
    account_type_bank_group: 'Bank Account',
    account_type_checking: 'Checking',
    account_type_savings: 'Savings',
    account_type_credit_card: 'Credit Card',
    account_type_investment: 'Investment',
    account_type_cash: 'Cash',
    account_type_other: 'Other',
    // Budget
    budget_title: 'Budget',
    budget_subtitle: 'Monthly budget management',
    budget_add: 'Add Budget',
    budget_copy_next: 'Copy to next month',
    budget_copy_done: 'Copied {copied} items (skipped {skipped})',
    budget_copy_error: 'Failed to copy',
    budget_total_label: 'Total Expense / Total Budget',
    budget_empty: 'No budgets set',
    budget_col_category: 'Category',
    budget_col_amount: 'Budget',
    budget_col_actual: 'Actual',
    budget_col_remaining: 'Remaining',
    budget_col_ratio: 'Usage',
    budget_col_actions: 'Actions',
    budget_delete_confirm: 'Delete this budget?',
    budget_modal_no_categories: 'No categories available',
    budget_modal_amount_label: 'Budget Amount (JPY)',
    budget_modal_amount_placeholder: 'e.g. 30000',
    budget_modal_invalid: 'Enter a valid category and amount',
    // Recurring
    recurring_title: 'Recurring Transactions',
    recurring_subtitle: 'Manage recurring transactions',
    recurring_add: '+ Add Recurring',
    recurring_pending_label: 'Unprocessed this month ({count}):',
    recurring_pending_item: '{description} ({date})',
    recurring_pending_separator: ', ',
    recurring_generate_success: 'Transaction registered',
    recurring_generate_error: 'Failed to register',
    recurring_archive_confirm: 'Archive this recurring item?',
    recurring_empty: 'No recurring items',
    recurring_col_name: 'Name',
    recurring_col_amount: 'Amount',
    recurring_col_category: 'Category',
    recurring_col_pattern: 'Pattern',
    recurring_col_next: 'Next Due',
    recurring_col_actions: 'Actions',
    recurring_archived_badge: 'Archived',
    recurring_register_today: 'Register Today',
    recurring_archive_title: 'Archive',
    recurring_modal_title: 'Add Recurring Transaction',
    recurring_form_name: 'Name',
    recurring_form_name_placeholder: 'e.g. Rent',
    recurring_form_type: 'Type',
    recurring_form_amount: 'Amount (JPY)',
    recurring_form_amount_placeholder: 'e.g. 80000',
    recurring_form_category: 'Category',
    recurring_form_account: 'Account',
    recurring_form_pattern: 'Pattern',
    recurring_form_day_of_month: 'Day of month',
    recurring_form_day_of_week: 'Day of week',
    recurring_form_month: 'Month',
    recurring_form_reminder: 'Enable reminder',
    recurring_form_excluded: 'Exclude from totals',
    recurring_form_excluded_hint: 'Transactions generated from this rule are excluded from totals.',
    recurring_pattern_monthly_fixed: 'Monthly (fixed day)',
    recurring_pattern_monthly_last: 'Monthly (last day)',
    recurring_pattern_weekly: 'Weekly',
    recurring_pattern_yearly: 'Yearly',
    recurring_modal_invalid: 'Please fill in all required fields',
    // Annual ledger
    ledger_title: 'Annual Ledger',
    ledger_subtitle: 'Scroll horizontally to review a full year of cash flow and balances',
    ledger_col_desc: 'Description',
    ledger_col_amount: 'Amount',
    ledger_col_total: 'Total',
    ledger_col_balance: 'Balance',
    ledger_opening_balance: 'Opening balance',
    ledger_excluded_note: 'Excluded transactions still move the balance but are left out of the monthly income and expense totals.',
    ledger_closing_balance: 'Closing balance',
    ledger_year_income: 'Annual income',
    ledger_year_expense: 'Annual expense',
    ledger_hide_empty: 'Hide days without transactions',
    ledger_month_empty: 'No transactions',
    ledger_search_placeholder: 'Search by description',
    ledger_search_no_match: 'No matching transactions',
    ledger_jump_today: 'This month',
    ledger_fetch_error: 'Failed to load the annual ledger',
    ledger_threshold_title: 'Balance color thresholds',
    ledger_threshold_low_label: 'Red below',
    ledger_threshold_high_label: 'Green at or above',
    ledger_threshold_reset: 'Reset to defaults',
    ledger_month_opening_balance: 'Opening balance',
    ledger_month_closing_balance: 'Closing balance',
    ledger_month_income: 'Monthly income',
    ledger_month_expense: 'Monthly expense',
    // Annual matrix (the cash-flow part of the life plan screen)
    matrix_col_category: 'Item',
    matrix_col_annual: 'Annual',
    matrix_total_income: 'Total income',
    matrix_total_expense: 'Total expense',
    matrix_total_transfer: 'Total transfers',
    matrix_net: 'Net',
    matrix_savings_rate: 'Savings rate',
    matrix_heatmap: 'Shade amounts',
    matrix_export_csv: 'Export CSV',
    matrix_uncategorized: 'Uncategorized',
    matrix_fetch_error: 'Failed to load the balance table',
    matrix_total_investment: 'Total investments',
    matrix_transfer_note: 'Transfers move money between your own accounts, so they are excluded from net and savings rate.',
    matrix_transfer_investment_note: 'Transfers and investments move money between your own assets, so they are excluded from net and savings rate. Investments are totalled from your brokerage trades (buys minus sells).',
    matrix_cumulative_investment: 'Show investments as a running total',
    matrix_cumulative_investment_note: 'With the running total on, investment cells accumulate from the start of the period (totals are unchanged).',
    matrix_open_transactions: 'Open transactions filtered by this cell',
    // Life plan
    lp_title: 'Life plan',
    lp_subtitle_month: 'Rows by item, columns by month — a year of cash flow next to the assets it builds',
    lp_subtitle_year: 'Rows by item, columns by year — past cash flow and the financial assets it projects',
    lp_unit_month: 'Monthly',
    lp_unit_year: 'Yearly',
    lp_col_item: 'Item',
    lp_col_year_total: 'Year',
    lp_col_year_total_hint: 'Period rows (income, expense, contribution) sum the 12 months; cumulative rows (balance, principal, gain/loss) show the December figure.',
    lp_balance: 'Financial assets',
    lp_final_balance: 'Financial assets in {year}',
    lp_year_end_balance: 'Financial assets at the end of {year}',
    lp_total_contribution: 'Total contribution',
    lp_total_principal: 'Total principal',
    lp_total_principal_hint: 'Contributions made through that year-end, across all buckets (cumulative)',
    lp_bucket_contribution: 'Contribution: {name}',
    lp_row_principal: 'Principal',
    lp_row_value: 'Value',
    lp_row_gain: 'Gain/loss',
    lp_row_return: 'Return',
    lp_total_gain: 'Gain/loss (total)',
    lp_total_period_gain: 'Change in gain/loss (total)',
    lp_total_gain_hint: 'Value minus principal at that period end, across all buckets (cumulative)',
    lp_period_cumulative: 'to date',
    lp_period_annual: 'in year',
    lp_period_month: 'in month',
    lp_period_cumulative_hint: 'Built up through that year-end (principal, value and gain/loss to date)',
    lp_period_cumulative_hint_month: 'Built up through that month-end (principal, value and gain/loss to date)',
    lp_period_annual_hint: 'That year alone (the year\'s contribution, gain/loss and return)',
    lp_period_month_hint: 'That month alone (the month\'s contribution, gain/loss and return — not annualized)',
    lp_period_legend: 'The tag next to each item name says whether the cells are “to date” (built up through that year-end) or “in year” (that year alone).',
    lp_period_legend_month: 'The tag next to each item name says whether the cells are “to date” (built up through that month-end) or “in month” (that month alone).',
    lp_total_period_gain_hint: 'Gain or loss that arose during the period, across all buckets (balance growth excluding contributions)',
    lp_total_return: 'Return (total)',
    lp_no_account_type: 'No account type',
    lp_no_member: 'No owner',
    lp_start_year: 'From',
    lp_end_year: 'Through',
    lp_show_returns: 'Show returns',
    lp_edit_assumption: 'Edit assumptions',
    lp_modal_title: 'Assumptions for {name}',
    lp_annual_amount: 'Annual contribution (JPY)',
    lp_return_rate: 'Expected return (%/year)',
    lp_return_rate_hint: 'Values from next year on compound at this rate. Left empty, the projection uses 0%.',
    lp_contribution_end_date: 'Last contribution date',
    lp_contribution_end_date_hint: 'Leave it empty to keep contributing through the last column. Stopping mid-year prorates that year by month (end of June = 6/12 of the annual amount).',
    lp_pivot: 'End of {year} (your current holdings)',
    lp_pivot_detail: 'Principal {principal} / Value {value}',
    lp_actual_return: 'Realized return since inception {rate}%',
    lp_scheme_nisa: 'NISA (both allowances)',
    lp_scheme_nisa_tsumitate: 'NISA tsumitate allowance',
    lp_scheme_nisa_growth: 'NISA growth allowance',
    lp_scheme_kodomo_nisa: 'Kodomo NISA (starts 2027)',
    lp_scheme_nisa_old_tsumitate: 'Tsumitate NISA (former)',
    lp_scheme_nisa_old_general: 'General NISA (former)',
    lp_scheme_junior_nisa: 'Junior NISA (former)',
    lp_scheme_ideco: 'iDeCo',
    lp_scheme_kyosai: 'Small enterprise mutual aid',
    lp_scheme_unknown: 'No contribution cap',
    lp_limit_annual: 'Annual cap {amount}',
    lp_limit_annual_varies: 'Annual cap {amount} (varies by enrollment category)',
    lp_limit_annual_none: 'No annual cap applies',
    lp_limit_lifetime: 'Lifetime tax-free cap {limit} ({remaining} left)',
    lp_limit_group_note: 'The NISA lifetime cap is shared across one person\'s tsumitate and growth allowances and their Kodomo NISA (growth is capped at 12M within it, Kodomo NISA at 6M). Kodomo NISA holdings roll into the adult NISA at 18.',
    lp_limit_age: 'Contributions are allowed only while the owner is under {age} on January 1 of that year (buckets with no birth date on file are not capped).',
    lp_limit_closed: 'This scheme no longer accepts new contributions, so the projection uses 0.',
    lp_limit_error_annual: 'This exceeds the annual cap of {amount}.',
    lp_limit_filled: 'Hits the lifetime tax-free cap in {year}; contributions after that are 0',
    lp_actual_return_none: 'No realized return can be computed (no trades on record)',
    lp_empty: 'No transactions or investment products yet. Add transactions to see cash flow, and add a brokerage with its holdings on the Investments page to see the buckets and the projection.',
    lp_month_forecast_note: 'Elapsed months come from your brokerage trades; months still ahead are prorated from the annual contribution and compounded monthly at the expected return (the remaining months of this year do not apply the lifetime allowance).',
    lp_export_csv: 'Export CSV',
    lp_fetch_error: 'Failed to load the life plan',
    lp_unpriced_note: '{count} holdings have no price yet, so their value falls back to acquisition cost.',
    lp_note: 'Through {year} the figures are actuals from your trades (each year-end value reprices the holdings of that year at the latest trade price known then; returns use the Modified Dietz method, treating contributions as mid-year). The {year} column is your current holdings as-is, and from the following year on the table projects each bucket at its expected return and annual contribution, capped by the scheme (NISA allows 1.2M/year tsumitate, 2.4M/year growth and 0.6M/year Kodomo NISA, with an 18M lifetime cap shared across one person\'s allowances, 12M of it available to growth and 6M to Kodomo NISA; Kodomo NISA stops in the year its owner turns 18; former schemes and Junior NISA take no new contributions). Taxes and fees are ignored.',
    // Reports
    reports_title: 'Reports',
    reports_view_monthly: 'Monthly',
    reports_view_annual: 'Annual',
    reports_year_label: '{year}',
    reports_trend_title_daily: 'Daily Trend ({month}/{year})',
    reports_jump_current_month: 'This month',
    reports_jump_current_year: 'This year',
    reports_trend_title_annual: 'Monthly Trend ({year})',
    reports_category_title: 'Expense by Category',
    reports_category_detail_title: 'Expense Category Details',
    reports_no_data: 'No data',
    reports_col_category: 'Category',
    reports_col_amount: 'Amount',
    reports_col_ratio: 'Ratio',
    reports_open_transactions: 'Open transactions for this category and period',
    reports_income: 'Income',
    reports_expense: 'Expense',
    reports_balance: 'Balance',
    reports_tooltip_income_label: 'Income: {amount}',
    reports_tooltip_expense_label: 'Expense: {amount}',
    reports_tooltip_balance_label: 'Balance: {amount}',
    // Auth
    auth_login_title: 'Log in',
    auth_login_submit: 'Log in',
    auth_login_submitting: 'Logging in...',
    auth_login_error: 'Failed to log in',
    auth_register_title: 'Create Account',
    auth_register_submit: 'Create account',
    auth_register_submitting: 'Registering...',
    auth_register_error: 'Failed to register',
    auth_email: 'Email address',
    auth_password: 'Password',
    auth_display_name: 'Display name',
    auth_password_hint: 'At least 8 characters with letters and numbers',
    auth_show_password: 'Show password',
    auth_hide_password: 'Hide password',
    auth_no_account: "Don't have an account?",
    auth_have_account: 'Already have an account?',
    auth_to_register: 'Sign up',
    auth_to_login: 'Log in',
    // Institution combobox
    institution_no_result: 'No matches',
    member_no_result: 'No matches',
    // Category combobox
    category_search_placeholder: 'Search categories',
    select_search_placeholder: 'Search',
    select_no_result: 'No matches',
    select_multi_summary: '{label} +{count}',
  },
} as const

export type TranslationKey = keyof typeof translations.ja
